import { AgentRoutes } from "@/modules/agent/routes";
import { TPRADashboardRoutes } from "@/modules/agent/routes/tpraDashboard";
import { AssistantRoutes } from "@/modules/assistant/routes";
import Authenticate from "@/modules/auth/components/authenticate-token";
import Login from "@/modules/auth/components/login";
import { ComplianceRoutes } from "@/modules/compliance/routes";
import { InternalRiskRoutes } from "@/modules/internal-risk/routes";
import { ThirdPartyRiskRoutes } from "@/modules/third-party-risk/routes";
import { AgentSessionRoutes } from "@/modules/sessions/routes";
import { SettingsRoutes } from "@/modules/settings/routes";
import { TeamRoutes } from "@/modules/team/routes";
import { ROUTES } from "@/shared/constants/routes";
import { Navigate, RouteObject } from "react-router-dom";
import MainLayout from "../components/layout";
import DefaultRedirect from "../components/default-redirect";
import VendorIntakeForm from "@/modules/vendors/third-party-evaluation-form";

export const AppUnprotectedRoutes: RouteObject[] = [
  {
    path: ROUTES.AUTH,
    // lazy: importLazy(() => import("@/modules/auth/components/authenticate-token"),),
    Component: Authenticate
  },
  {
    path: ROUTES.LOGIN,
    // lazy: importLazy(() => import("@/modules/auth/components/login")),
    Component: Login
  },
  {
    path: ROUTES.SELECT_ORG,
    Component: Login
  },
  {
    path: ROUTES.VENDOR_DETAILS,
    Component: VendorIntakeForm
  },
  {
    path: "*",
    element: <Navigate to={ROUTES.LOGIN} replace={true} />,
  },
];

export const MainRoutes: RouteObject[] = [
  ...AgentRoutes,
  ...TPRADashboardRoutes,
  ...ComplianceRoutes,
  ...InternalRiskRoutes,
  ...ThirdPartyRiskRoutes,
  ...SettingsRoutes,
  ...TeamRoutes,
  ...AgentSessionRoutes,
  ...AssistantRoutes,

  {
    path: "*",
    Component: DefaultRedirect,
  },
];

export const AppProtectedRoutes: RouteObject[] = [
  {
    path: "/*",
    // lazy: importLazy(() => import("../components/layout")),
    Component: MainLayout,
    children: [...MainRoutes],
  },
];
